export default "__VITE_ASSET__BPj6mSyS__"